module.exports = __webpack_public_path__ + "assets/img/training_vector.af52856a.svg";